import { useUserDevices } from "../../hooks/useUserDevices";
import { User } from "../../types/user";

interface DevicesTabProps {
    user: User;
}

export default function DevicesTab({ user }: DevicesTabProps) {
    const devices = useUserDevices({
        email: user.email ?? undefined,
        phone: user.phone ?? undefined,
      });

          // Format date as yyyy-mm-dd
    const formatDate = (date: Date) => {
        const options: Intl.DateTimeFormatOptions = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        };
        return date.toLocaleString("en-US", options);
    };
      
    return (
        <div className="w-full bg-card rounded-xl p-4">
            <table className="w-full text-xs table-fixed">
                <thead className="border-b border-gray-400 text-gray-200">
                    <tr>
                        {/* <th className="w-1/10 text-center font-light py-2">Service</th> */}
                        <th className="w-1/10 text-center font-light py-2">Device Name</th>
                        <th className="w-1/10 text-center font-light py-2">Platform</th>
                        <th className="w-1/10 text-center font-light py-2">Model</th>
                        <th className="w-1/10 text-center font-light py-2">Last Active</th>
                        <th className="w-1/10 text-center font-light py-2">Action</th>
                    </tr>
                </thead>

                <tbody className="text-white">
                    {devices.map((device) => (
                        <tr className="bg-card/50">
                        {/* <td className="w-1/10 text-center py-2">{device.serviceName}</td> */}
                        <td className="w-1/10 text-center py-2">{device.name}</td>
                        <td className="w-1/10 text-center py-2">{device.os}</td>
                        <td className="w-1/10 text-center py-2">{device.model}</td>
                        <td className="w-1/10 text-center py-2">{formatDate(new Date(device.lastUsedAt))}</td>
                        <td className="w-1/10 text-center py-2">
                            <button className="bg-none border border-white text-white rounded-lg py-1 px-2 hover:scale-105 cursor-pointer">Deactivate</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}